export default function Services() {
  const services = [
    {
      number: '01',
      title: 'Car Accidents',
      description: 'Comprehensive representation for victims of automobile collisions, including rear-end accidents, intersection crashes, and hit-and-run incidents.',
      link: '/car-accidents'
    },
    {
      number: '02',
      title: 'Workplace Injuries',
      description: 'Protecting the rights of injured workers, including construction accidents, repetitive stress injuries, and occupational diseases.',
      link: '/workplace-injuries'
    },
    {
      number: '03',
      title: 'Medical Malpractice',
      description: 'Holding healthcare providers accountable for surgical errors, misdiagnosis, medication mistakes, and birth injuries.',
      link: '/medical-malpractice'
    },
    {
      number: '04',
      title: 'Slip and Fall',
      description: 'Premises liability cases involving dangerous conditions, inadequate maintenance, and negligent property management.',
      link: '/slip-and-fall'
    },
    {
      number: '05',
      title: 'Wrongful Death',
      description: 'Compassionate representation for families who have lost loved ones due to negligence or intentional harm.',
      link: '/wrongful-death'
    },
    {
      number: '06',
      title: 'Dog Bite',
      description: 'Aggressive representation for victims of dog attacks and animal bites, covering medical expenses, scarring, emotional trauma, and long-term damages.',
      link: '/dog-bite'
    }
  ];

  const immigrationLinks = [
    {
      title: 'Immigration Law',
      link: '/immigration',
      external: false
    },
    {
      title: 'Marriage-Based Green Card',
      link: 'https://www.marriagegreencard-junlawfirm.com',
      external: true
    }
  ];

  return (
    <section id="services" className="py-16 bg-lavender-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="mb-12">
          <p className="text-xs tracking-[0.3em] uppercase text-gray-500 mb-4">Practice Areas</p>
          <h2 className="text-6xl md:text-7xl font-light text-gray-900 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
            Areas of<br />
            <span className="italic font-normal">Expertise</span>
          </h2>
        </div>

        {/* Services grid */}
        <div className="space-y-1">
          {services.map((service, index) => (
            <a key={index} href={service.link} className="block group">
              <article className="bg-lavender-50 border-b border-gray-200 py-8 px-8 hover:bg-gray-900 transition-colors duration-300">
                <div className="flex items-start gap-8">
                  <span className="text-5xl font-light text-gray-300 group-hover:text-gray-600 transition-colors" style={{ fontFamily: "'Playfair Display', serif" }}>
                    {service.number}
                  </span>
                  <div className="flex-1">
                    <h3 className="text-3xl font-light text-gray-900 group-hover:text-white mb-3 transition-colors" style={{ fontFamily: "'Playfair Display', serif" }}>
                      {service.title}
                    </h3>
                    <p className="text-sm text-gray-600 group-hover:text-gray-300 leading-relaxed max-w-3xl transition-colors" style={{ fontFamily: "'Inter', sans-serif" }}>
                      {service.description}
                    </p>
                  </div>
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xl text-gray-400 group-hover:text-white transition-colors"></i>
                  </div>
                </div>
              </article>
            </a>
          ))}

          {/* Immigration sub-links */}
          <div className="bg-lavender-50 border-b border-gray-200 px-8 py-5 flex flex-wrap gap-x-10 gap-y-3 items-center">
            <span className="text-[11px] tracking-[0.25em] uppercase text-gray-400 mr-2" style={{ fontFamily: "'Inter', sans-serif" }}>
              Immigration
            </span>
            {immigrationLinks.map((item, idx) => (
              <a
                key={idx}
                href={item.link}
                {...(item.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                className="group flex items-center gap-3 cursor-pointer"
              >
                <span className="block w-5 h-[2px] bg-gray-800 group-hover:w-8 transition-all duration-300"></span>
                <span
                  className="text-[13px] font-bold tracking-wider uppercase text-gray-800 group-hover:text-gray-500 transition-colors whitespace-nowrap"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  {item.title}
                </span>
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`${item.external ? 'ri-external-link-line' : 'ri-arrow-right-line'} text-sm text-gray-500 group-hover:text-gray-400 transition-colors`}></i>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
